import React, { useState, useEffect, ChangeEvent } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import FormFileGroup from '../../../elements/formElements/FormFileGroup';
import SubmitButton from '../../../elements/formElements/SubmitButton';
import axios from '../../../services/MyAxios';
import { CasinoDepositBonus } from '../../Models/CasinoDepositBonus';
import { API_CASINO_DEPOSIT_BONUSES, API_CASINO_UPLOAD_PNG_IMAGE } from '../Helpers/CrmApiUrls';
import { CASINO_DEPOSIT_BONUSES } from '../Helpers/CrmUrls';

import SweetAlert from 'crm/elements/alerts/SweetAlert';

interface RouteParams {
    id: string;
}

function DepositBonusCreate() {
    const history = useHistory();
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [depositBonus, setDepositBonus] = useState<CasinoDepositBonus>({
        id: 0,
        name: '',
        casino_deposit_bonus_page_id: 0,
        currency_code: '',
        image_path: '',
        description: '',
        min_deposit: 1,
        max_deposit: 1,
        bonus_percentage: 1.0,
        wagering_requirement: 1,
        count_of_days_to_fill_requirements_by_user: 1,
        available_from: '',
        available_to: '',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const { id } = useParams<RouteParams>();

    useEffect(() => {
        const url = `${API_CASINO_DEPOSIT_BONUSES}/${id}`;
        axios
            .get(url)
            .then((response) => {
                setDepositBonus(response.data);
            })
            .catch((error) => {
                if (error.response.status && error.response.status === 404) {
                    history.push({ pathname: CASINO_DEPOSIT_BONUSES });
                }
            });
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();

        axios
            .patch(`${API_CASINO_DEPOSIT_BONUSES}/${id}/edit`, depositBonus)
            .then(() => {
                SweetAlert.success('Bonus page updates correctly').then(() => {
                    history.push({ pathname: CASINO_DEPOSIT_BONUSES });
                });
            })
            .catch((error) => {
                if (!error.response) {
                    setErrors(error.message);
                } else if (error.response.status !== 500) {
                    setErrors(error.response.data.errors);
                } else {
                    SweetAlert.error('Server error');
                }
            });
    };

    const uploadImage = (image: File) => {
        axios
            .post(
                API_CASINO_UPLOAD_PNG_IMAGE,
                { image, dir: 'deposit-bonus' },
                {
                    headers: {
                        Accept: 'application/json',
                        'content-type': 'multipart/form-data',
                    },
                }
            )
            .then((response) => {
                const url = response.data.url;
                setDepositBonus({
                    ...depositBonus,
                    image_path: url,
                });
            })
            .catch(() => {
                SweetAlert.error('Server error');
            });
    };

    function hasErrorFor(field) {
        return !!errors[field];
    }

    function renderErrorFor(field) {
        if (hasErrorFor(field)) {
            return (
                <span className="invalid-feedback" style={{ display: 'block' }}>
                    <strong>{errors[field][0]}</strong>
                </span>
            );
        }
        return '';
    }

    return (
        <div className="card">
            <div className="card-body">
                <form className="form-flex">
                    <div className="form-group">
                        {depositBonus.image_path && (
                            <img
                                src={depositBonus.image_path}
                                style={{ maxWidth: '100px', height: 'auto' }}
                                alt="current icon"
                            />
                        )}
                        <label htmlFor="image_path">
                            Image in .png format: <br />
                            <input
                                className="form-control"
                                type="file"
                                accept=".png"
                                name="image_path"
                                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                    uploadImage(event.target.files[0]);
                                }}
                            />
                        </label>
                        {renderErrorFor('image_path')}
                    </div>
                    <SubmitButton label="Update" onClick={handleSubmit} />
                </form>
            </div>
        </div>
    );
}

export default DepositBonusCreate;
